import Main from '@/pages/Home/Main'

export default [
    {
        path: '',
        component: Main
    },
    {
        path: 'home',
        component: Main
    }
]
